import React from 'react';
import { connect, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import { GlobalReducerState } from 'app/reducers';
// import { updateJVPUserUiSettings } from 'Containers/App/actions';
// import { DirectlyUpdateableJVPUserAttributes } from 'Utils/apiTypes';
import { makeSelectConfigField } from 'Containers/App/selectors';
import { Moment } from 'Containers/MomentPage/Moment';
import { makeGetMomentSettings, makeSelectMomentPageField } from 'Containers/MomentPage/selectors';

import { submitMtmFeedback } from './actions';

interface MomentPageStateProps {
  client: string;
  feedbackSubmitted: boolean;
}

interface MomentPageDispatchProps {
  // updateJVPUserUiSettings: (uiSettings: Partial<DirectlyUpdateableJVPUserAttributes>) => void;
  handleFeedbackSubmit: () => void;
}

export type MomentPageProps = MomentPageStateProps & MomentPageDispatchProps;

export const MomentPage = ({ client, handleFeedbackSubmit, feedbackSubmitted }: MomentPageProps) => {
  // const [booped, setBooped] = React.useState(false);
  const [searchParams] = useSearchParams();

  const topic = searchParams.get('topic');
  const momentCodename = searchParams.get('moment');
  const planYear = parseInt(searchParams.get('planyear') ?? searchParams.get('planYear') ?? '2025', 10);
  const momentSettingsByPlanYear = useSelector(makeGetMomentSettings(planYear));

  if (!topic) {
    return null;
  }
  // this exists to get a screen interaction before loading SBR when jumping straight to this route and not getting to it via the unified landing page. obviously not the thing we would actually
  // use but the need to get a screen interaction before loading SBR is a ux problem we'll have to tackle if the expected flow is loading straight into the MTM page.
  // if(!booped) {
  //   return (
  //     <Button onClick={() => setBooped(true)}>Plz boop</Button>
  //   )
  // }

  return (
    <Moment
      codename={momentCodename}
      topic={topic}
      client={client}
      handleFeedbackSubmit={handleFeedbackSubmit}
      feedbackSubmitted={feedbackSubmitted}
      publicationsGoSettings={momentSettingsByPlanYear}
    />
  );
};

const mapStateToProps = () =>
  createStructuredSelector<GlobalReducerState, MomentPageStateProps>({
    client: makeSelectConfigField('client'),
    feedbackSubmitted: makeSelectMomentPageField('feedbackSubmitted'),
  });

export function mapDispatchToProps(dispatch): MomentPageDispatchProps {
  return {
    // updateJVPUserUiSettings: (uiSettings: Partial<DirectlyUpdateableJVPUserAttributes>) =>
    //   dispatch(updateJVPUserUiSettings(uiSettings)),
    handleFeedbackSubmit: () => dispatch(submitMtmFeedback()),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(MomentPage);
